import React from "react";

import "./App.css";

export default function App() {
  return (
    <div className="App">
      <h1>Weather Search Engine</h1>
    </div>
  );
}